import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { FuelOrder } from 'app/models2/fuel/fuel-order';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HttpService, MessageService } from 'brainloper-ui';

@Component({
  selector: 'app-fuel-history-detail',
  templateUrl: './fuel-history-detail.component.html',
  styleUrls: ['./fuel-history-detail.component.scss']
})
export class FuelHistoryDetailComponent implements OnInit {

  private urlPutHistoric: string = `${EndpointDictionary.HistoricalFuel.PUT_HISTORICAL_FUEL}`
  public formPutFO: UntypedFormGroup

  constructor(
    public dialogRef: MatDialogRef<FuelHistoryDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FuelOrder,
    private message: MessageService,
    private http: HttpService,
    private formBuilder: UntypedFormBuilder,

  ) {
    this.formPutFO = this.formBuilder.group(
      {
        id:this.data.id,
        totalPrice:"",
        billNumber:"",
        salesOrder:"",
        currentOdometer:0
    }
    )
  }

  ngOnInit(): void {
    this.message.openLoading('Cargando', 'Cargando información')
     this.initFild()
  }

  initFild(){
    this.message.closeLoading()
    this.formPutFO.controls.totalPrice.setValue(this.data.totalPrice)
    this.formPutFO.controls.billNumber.setValue(this.data.billNumber)
    this.formPutFO.controls.salesOrder.setValue(this.data.salesOrder)
    this.formPutFO.controls.currentOdometer.setValue(this.data.orderOdometer)
  }

  async updateHistory(form: FuelOrder){
    this.message.openLoading('Cargando', 'Actualizando Información')

    form.totalPrice = parseFloat(form.totalPrice.toString().replace(/[,.]/g, ''))
    let res: GenericResponse = await this.http.putDataBody(`${this.urlPutHistoric}`, form)
    if(res){
        this.message.closeLoading()
        this.dialogRef.close()
      }
  }

  errorMessage(){
    this.message.Error('Error', 'complete los campos')
  }

}
